import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { Button, Grid, Select, TextField } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';

function CommitteeMemberForm(props) {
    const SCHEMA = {
        "id": 0,
        "committeeID": parseInt(props.committeeID),
        "personID": 0,
        "yearAppointed": 0,
        "membershipExpires": "",
        "membershipType": "",
        "person": {
          "id": 0,
          "name": "",
          "personData": ""
        }
      };
    // Key
    //const { member } = props;
    // Visual feedbacks
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    // Data
    const [ committeeMember, setCommitteeMember ] = useState(props.member || SCHEMA);
    const [ personData, setPersonData ] = useState({address: "", email: "", phone: ""});
    // Events
    const { onClose, onSave } = props;

    // Data Manipulation
    useEffect(() => {
      if (committeeMember.person.personData && committeeMember.person.personData.data) {
        setPersonData(JSON.parse(committeeMember.person.personData.data));
      } else {
        setPersonData({address: "", email: "", phone: ""});
      }
    }, [committeeMember.person.personData]);

    // FORM SYNC
    const handleFieldChange = event => { setCommitteeMember({...committeeMember, [event.target.name]: event.target.value }) };
    const handlePersonNameChange = event => { setCommitteeMember({...committeeMember, person: {...committeeMember.person, name: event.target.value}}); };
    const handlePersonDataChange = event => { setPersonData({...personData, [event.target.name]: event.target.value }); };
    // Data Transformation for saving
    const _toAPIDataModel = (id, data, personData) => {
      if (id) { //Updating
        return {
          Person: { ID: data.personID, Name: data.person.name },
          PersonData: personData && (personData.address || personData.email || personData.phone) ? { PersonID: data.personID, Data: JSON.stringify(personData) } : null, // extra data stored as JSON string, in Data field related to person.
          CommitteeMember: { ID: data.id, CommitteeID: data.committeeID, PersonID: data.personID, YearAppointed: data.yearAppointed, MembershipExpires: data.membershipExpires, MembershipType: data.membershipType }
        }
      } else { // Creating
        return {
          Person: { Name: data.person.name },
          PersonData: personData && (personData.address || personData.email || personData.phone) ? { PersonID: data.personID, Data: JSON.stringify(personData) } : null, // extra data stored as JSON string, in Data field related to person.
          CommitteeMember: { CommitteeID: data.committeeID, PersonID: data.personID, YearAppointed: data.yearAppointed, MembershipExpires: data.membershipExpires, MembershipType: data.membershipType }
        }
      }
    }
    // FORM SUBMIT
    const saveAction = event => {
      // prevent default save
      event.preventDefault();
      event.stopPropagation();
      // check validity???

      // transform to model view for person and attribute saving
      const viewModel = _toAPIDataModel(committeeMember.id, committeeMember, personData);
      // save API
      fetch(`https://api2.auburnalabama.org/committee/member/${(committeeMember.id || '')}`, { credentials: 'include', headers: { 'Content-Type': 'application/json' }, method: committeeMember.id ? 'PUT' : 'POST', body: JSON.stringify(viewModel) })
        .then((response) => { if (response.ok) return true; else throw new Error(response.status); }) //no-content expected on successful PUT
        .then(() => {
          enqueueSnackbar('Saved', { variant: 'success' });
          onSave();
        })
        .catch((e) => {
            // save the work?
            enqueueSnackbar(`Save FAILED. (${e})`, { variant: 'error', persist: true, action: (key) => (
                <Button onClick={(key) => closeSnackbar(key)}>Dismiss</Button>
            )});
        });
      // run close event from parent
      onClose();
    }
    // MEMBER DELETE
    const deleteAction = event => {
      if (window.confirm("Are you sure you wish to delete?")) {
        fetch(`https://api2.auburnalabama.org/committee/member/${committeeMember.id}`, { credentials: 'include', method: 'DELETE'})
          .then((response) => { if (response.ok) return true; else throw new Error(response.status); })
          .then(() => {
            enqueueSnackbar('Deleted', { variant: 'success' });
            onSave();
          })
          .catch((e) => {
              enqueueSnackbar(`Delete FAILED. (${e})`, { variant: 'error', persist: true, action: (key) => (
                  <Button onClick={(key) => closeSnackbar(key)}>Dismiss</Button>
              )});
          });
        onClose();
      }
    }
    // CANCEL ACTION
    const cancelAction = onClose;
    
    return (
        <form action={`https://api2.auburnalabama.org/commitee/member/${committeeMember.id}`} method="PUT" onSubmit={saveAction}>
            <input type="hidden" id="memberID" name="ID" value={committeeMember.id}></input>
            <input type="hidden" name="CommitteeID" value={committeeMember.committeeID}></input>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12}>
                <TextField id="memberName" type="text" name="person.name" className="fullWidth" required autoFocus
                  label="Name"
                  value={committeeMember.person.name} onChange={handlePersonNameChange}></TextField>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField type="number" name="yearAppointed" className="fullWidth" required 
                  label="Year Appointed" min="1980" max="2030"
                  value={committeeMember.yearAppointed} onChange={handleFieldChange}></TextField>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField type="date" name="membershipExpires" className="fullWidth" 
                  label="Membership Expires"
                  value={committeeMember.membershipExpires} onChange={handleFieldChange}></TextField>
              </Grid>
              <Grid item xs={12}>
                <Select native className="fullWidth" SelectDisplayProps={{'aria-label': 'List Selector'}}
                        value={committeeMember.membershipType} onChange={handleFieldChange} inputProps={{'name': 'membershipType'}}>
                          <option value="">Member</option>
                          <option value="Supernumerary">Supernumerary</option>
                          <option value="Ex-Offico">Ex-Offico</option>
                        </Select>
              </Grid>
              <br></br>
              <Grid item xs={12}>
                <TextField type="text" name="address" className="fullWidth"
                  label="Address"
                  value={personData.address} onChange={handlePersonDataChange}></TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField type="tel" name="phone" className="fullWidth"
                  label="Phone" pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                  value={personData.phone} onChange={handlePersonDataChange}></TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField type="email" name="email" className="fullWidth"
                  label="Email"
                  value={personData.email} onChange={handlePersonDataChange}></TextField>
              </Grid>
              <Grid item xs={12} style={{ textAlign: 'right' }}>
                <Button variant="outlined" size="small" className="warning" style={{ marginRight: '10px' }} onClick={deleteAction}>
                  <DeleteIcon /> Delete
                </Button>
                <Button variant="outlined" size="small" color="secondary" style={{ marginRight: '10px' }} onClick={cancelAction}>
                  <CancelIcon /> Cancel
                </Button>
                <Button variant="contained" size="small" color="primary" type="submit">
                    <SaveIcon /> Save
                </Button>
              </Grid>
            </Grid>
        </form>
    )
}

export default CommitteeMemberForm;
